import { useCallback, useEffect, useState } from 'react';
import { getErrorMessage, paymentAPI } from '../services/api';

export function usePayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize] = useState(10);
  const [status, setStatus] = useState(null);
  const [centerId, setCenterId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = useCallback(() => {
    setRefreshKey((value) => value + 1);
  }, []);

  useEffect(() => {
    let active = true;

    const loadPayments = async () => {
      setLoading(true);
      setError('');

      try {
        const response = await paymentAPI.getPayments({ page, pageSize, status, centerId });
        if (!active) {
          return;
        }

        setPayments(response.data.items ?? []);
        setTotal(response.data.total ?? 0);
      } catch (err) {
        if (active) {
          setError(getErrorMessage(err));
          setPayments([]);
          setTotal(0);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadPayments();

    return () => {
      active = false;
    };
  }, [page, pageSize, status, centerId, refreshKey]);

  return {
    payments,
    loading,
    error,
    page,
    setPage,
    total,
    pageSize,
    status,
    setStatus,
    centerId,
    setCenterId,
    refresh,
  };
}

export function usePaymentStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const response = await paymentAPI.getStats();
      setStats(response.data);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { stats, loading, error, refresh: load };
}
